import { ExternalLink } from "lucide-react";

export default function BlockCodingContent(props) {
  const { title, description, contribution, link } = props;

  return (
    <div className="card">
      <div className="flex items-start justify-between gap-4 mb-3">
        <h3 className="text-lg font-medium text-foreground">{title}</h3>
        {link && (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 text-muted hover:text-foreground transition-colors"
            aria-label="View project"
          >
            <ExternalLink size={18} />
          </a>
        )}
      </div>
      <p className="text-muted text-sm leading-relaxed mb-3">{description}</p>
      {contribution && (
        <p className="text-muted text-sm leading-relaxed">{contribution}</p>
      )}
    </div>
  );
}
